export default "__VITE_ASSET__52b0b978__"